export const STATUS_QUEUED = 'queued';
export const STATUS_LEASED = 'leased';
export const STATUS_GRADED = 'graded';
export const STATUS_QUEUED_AND_LEASED = 'active';
